/**
 * Fix the conflict between the Sitecore Experience Editor libraries and Vue.
 */
class SitecoreMixin {
  /**
   * Before create the root element, find all of the placeholder <code> elements
   * and store the id and placeholder key pairing into the array.
   */
  beforeCreate() {
    this.$placeholderKeys = this.$slots.default && [
      ...this.$slots.default.filter(
        (slot) => slot.tag === 'code'
        && slot.data.attrs.chrometype === 'placeholder'
        && slot.data.attrs.kind === 'open'
      )
    ].map((slot) => ({
      id: slot.data.attrs.id,
      key: slot.data.key
    }))
  }

  /**
   * Before mount the root element, catch the key of root element.
   */
  beforeMount() {
    if (!this.$el) {
      return
    }
    this.dom = {}

    const dom = this.$el.getElementsByTagName('*')
    const key = this.$el.getAttribute('key')

    if (this.$el.id !== '' && key !== null) {
      this.dom[this.$el.id] = key
    }

    const max = dom.length

    for (let i = 0; i < max; i += 1) {
      const el = dom[i]
      const elKey = el.getAttribute('key')

      if (el.id !== '' && elKey !== null) {
        if (this.dom[el.id] === undefined) {
          this.dom[el.id] = elKey
        } else {
          throw new RangeError(`The id "${el.id}" is already set`)
        }
      }
    }
  }

  /**
   * When mounted components get the vnode key value, update the key attribute using
   * the scKey attribute.
   */
  mounted() {
    if (!this.dom) {
      return
    }

    const key = this.dom[this.$el.id]
    if (key) {
      this.$el.setAttribute('key', key)
    }

    const dom = this.$el.getElementsByTagName('*')
    const max = dom.length

    for (let i = 0; i < max; i += 1) {
      const el = dom[i]
      const elKey = this.dom[el.id]

      if (elKey) {
        el.setAttribute('key', elKey)
      }
    }

    /**
     * if there are mapped placeholder keys,
     * reset the key attribute on the placeholder
     * <code> elements
     */
    if (this.$placeholderKeys && this.$placeholderKeys.length > 0) {
      this.$placeholderKeys
        .forEach((entry) => document
          .getElementById(entry.id)
          .setAttribute('key', entry.key))
    }
  }

  /**
   * Install the global plugin for handle key issue on Sitecore editor.
   * @param {Vue}
   */
  static install(Vue) {
    this.instance = new SitecoreMixin(Vue)

    Vue.mixin({
      beforeCreate: this.instance.beforeCreate,
      beforeMount: this.instance.beforeMount,
      mounted: this.instance.mounted,
    })
  }
}

export default {
  install(Vue) {
    return SitecoreMixin.install(Vue)
  }
}
